/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import BookingLoginReservationDetailButton
    from "pages/Front/Booking/BookingLogin/components/BookingLoginReservationDetail/components/BookingLoginReservationDetailButton";
import {ReceiptPercentIcon, TrashIcon} from "@heroicons/react/24/solid";
import {useTranslation} from "react-i18next";
import {useDispatch} from "useDispatch";
import {PackagesCartItem} from "types/entities/PackagesCartItem";
import clsx from "clsx";
import {openModal} from "helpers/actions";
import {ModalSize} from "pages/Front/components/Popup";
import BookingSellerDiscountModal
    from "pages/Front/Booking/Seller/BookingSellerReservationDetail/components/BookingSellerDiscountModal";
import AlertConfirmation from "pages/Front/Registration/components/AlertConfirmation";
import {toast} from "react-toastify";
import {Reservation} from "types/entities/Reservation";
import SellerAction from "store/seller/SellerAction";

interface BookingSellerReservationDetailUpsellActionsProps {
    packagesCartItem: PackagesCartItem;
    reservation: Reservation;
    className?: string;
}

const BookingSellerReservationDetailUpsellActions = (props: BookingSellerReservationDetailUpsellActionsProps) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const onRemoveHandler = (packagesCartItem: PackagesCartItem) => {
        AlertConfirmation({
            message: t("You are about to remove an upsell, only admin can reverse this."),
            onClick: () => onConfirmRemoveHandler(packagesCartItem),
            title: t("Remove upsell"),
        });
    };

    const onConfirmRemoveHandler = (packagesCartItem: PackagesCartItem) => {
        dispatch(SellerAction.fetchDeleteUpsell(props.reservation.id, packagesCartItem)).then(r => {
            // dispatch(SellerAction.setReservation(r.reservation));
            toast.warn(t("Upsell deleted"));
        });
    };

    const onDiscountHandler = (packagesCartItem: PackagesCartItem) => {
        dispatch(
            openModal(<BookingSellerDiscountModal packagesCartItem={packagesCartItem}
                                                  reservation={props.reservation} />, {
                modalSize: ModalSize.Scrollable,
            }),
        );
    };

    return (
        <div
            className={clsx("BookingSellerReservationDetailUpsellActions flex flex-row justify-center gap-x-2", props.className)}>
            <BookingLoginReservationDetailButton
                className={"border-purple-400 bg-purple-400 h-[30px]"}
                onClick={() => onDiscountHandler(props.packagesCartItem)}
            >
                <ReceiptPercentIcon className={"w-4 h-4 flex-none"} />
            </BookingLoginReservationDetailButton>
            <BookingLoginReservationDetailButton className={"border-red-400 bg-red-400 h-[30px]"}
                                                 onClick={() => onRemoveHandler(props.packagesCartItem)}>
                <TrashIcon className={"w-4 h-4 flex-none"} />
            </BookingLoginReservationDetailButton>
        </div>
    );
};

export default BookingSellerReservationDetailUpsellActions;
